import { GridExceljsProcessInput, GridPrintExportOptions, GridToolbar } from "@mui/x-data-grid-premium"
import { DateTime } from "luxon"

interface ICustomToolbarProps {
    fileName?: string,
    exportTitle?: string,
    includeDateTime?: boolean
} 

export const createCustomToolbarProps = ({
    fileName,
    exportTitle,
    includeDateTime
}: ICustomToolbarProps) => {
    return {
        slots: {toolbar: GridToolbar},
        slotProps: {
            toolbar: {
                printOptions: {
                    hideToolbar: true,
                    hideFooter: true,
                    fileName: fileName,
                    /** 
                    * This still doesn't work properly, I'm pretty sure there's no good way to do this internally to MUI
                    * and we might need to build them manually. The only real issue is that this doesn't auto-scale which means they'll
                    * have to do it themselves. Not ideal but the alternative could take a little while to develop.
                    */ 
                    pageStyle: `
                        body::before {
                            content: "${exportTitle?.replace(/"/g, '\\"')}";
                        }
                        .MuiDataGrid-root, .MuiDataGrid-main, .MuiDataGrid-window {
                            overflow: visible !important;
                        }
                        .MuiDataGrid-root, .MuiDataGrid-main {
                            max-width: 100%;
                        }
                        .MuiDataGrid-columnHeaderTitle {
                            display: block !important;
                            white-space: normal !important;
                        }
                    `
                } as GridPrintExportOptions,
                excelOptions: {
                    fileName: fileName,
                    exceljsPreProcess: async (processInput: GridExceljsProcessInput) => {
                        if(includeDateTime) {
                            processInput.worksheet.addRow([DateTime.now().toFormat('dd/MM/yyyy hh:mm:ss')])
                        }
                        if(exportTitle) {
                            processInput.worksheet.addRow([exportTitle])
                        }
                    }
                }
            },
        },
        disableDensitySelector: true
    }
}

// export const CustomToolbarProps = {
//     slots: {toolbar: GridToolbar},
//     slotProps: {
//         toolbar: {
//             printOptions: {
//                 hideToolbar: true,
//             },
//         }
//     },
//     disableDensitySelector: true
// }